import Application from '@shared/application'
import router from './shapes/view/router'

import Vue from 'vue'
import Component from 'vue-class-component'
import { Variant } from '@ts/shared/interfaces'
import { Carousel, Slide } from 'vue-carousel'

import * as basicLightbox from 'basiclightbox'
import 'basiclightbox/dist/basicLightbox.min.css'

@Component({
  components: {
    Carousel,
    Slide,
  },
})
class ShapesView extends Vue {
  private relatedShapes: Variant[] = _state.relatedShapes.data
  private selectedMaterials: (string | null)[] = new Array(4).fill(null)

  private get hasRelatedShapes() {
    return this.relatedShapes !== undefined && this.relatedShapes.length > 0
  }

  get prevIcon(): string {
    return '<svg class="v-icon"><use xlink:href="#chevron-left"></use></svg>'
  }

  get nextIcon(): string {
    return '<svg class="v-icon"><use xlink:href="#chevron-right"></use></svg>'
  }

  private show(src: string) {
    const keyListener = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        instance.close()
      }
    }

    window.addEventListener('keyup', keyListener)

    const instance = basicLightbox.create(
      `
      <img src="${src}" width="800" height="600" />
    `,
      {
        onClose: () => {
          window.removeEventListener('keyup', keyListener)
          return true
        },
      },
    )

    instance.show()
  }
}

export default new Application(ShapesView, router)
